@if (filterNavigation()) {
<div class="filter-panel">
  @for (element of filterNavigation().filter; track element) {
  <div>
    <ish-filter-collapsible [filterElement]="element" [(collapsed)]="collapsedElements[element.name]">
      @switch (element.displayType) {
      <!-- default: text & text_clear -->
      @default {
      <ish-filter-text
        [filterElement]="element"
        (applyFilter)="applyFilter.emit($event)"
        [(showAll)]="showAllElements[element.name]"
      />
      }
      <!-- checkbox -->
      @case ('checkbox') {
      <ish-filter-checkbox
        [filterElement]="element"
        (applyFilter)="applyFilter.emit($event)"
        [(showAll)]="showAllElements[element.name]"
      />
      }
      <!-- swatch -->
      @case ('swatch') {
      <ish-filter-swatch-images [filterElement]="element" (applyFilter)="applyFilter.emit($event)" />
      }
      <!-- dropdown -->
      @case ('dropdown') {
      <div class="filter-dropdown">
        <ish-filter-dropdown
          [filterElement]="element"
          [placeholderType]="'selectedFacets'"
          (applyFilter)="applyFilter.emit($event)"
        />
      </div>
      } }
    </ish-filter-collapsible>
  </div>
  } @if (isOrderTemplate$ | async) { @if (isLoggedIn$ | async) {
  <custom-filter-dias-collapsible
    [title]="'account.ordertemplates.heading' | translate"
    [(collapsed)]="collapsedElements['order-template']"
  >
    <ish-error-message [error]="orderTemplateError$ | async" />
    @if (orderTemplateLoading$ | async) {
    <ish-loading />
    }
    <custom-filter-order-template [orderTemplates]="orderTemplates$ | async" />
  </custom-filter-dias-collapsible>
  } } @if (isWishlist$ | async) { @if ((isLoggedIn$ | async) && (isWishlist$ | async)) {
  <custom-filter-dias-collapsible [title]="'account.wishlists.heading' | translate">
    <ish-error-message [error]="wishlistError$ | async" />
    @if (wishlistLoading$ | async) {
    <ish-loading />
    }
    <custom-filter-wishlist [wishlists]="wishlists$ | async" />
  </custom-filter-dias-collapsible>
  } }
  <custom-filter-dias-collapsible
    [title]="'product.compare.link' | translate"
    [(collapsed)]="collapsedElements['order-template']"
  >
    <custom-filter-compare [compareProducts]="compareProducts$ | async" />
  </custom-filter-dias-collapsible>
</div>
}
